import { useState, useEffect } from 'react';

const navLinks = [
  { label: 'Home', href: '#home' },
  { label: 'About', href: '#about' },
  { label: 'Products', href: '#products' },
  { label: 'Features', href: '#features' },
  { label: 'Team', href: '#team' },
  { label: 'Contact', href: '#contact' },
];

export default function NavBar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 60);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleNavClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
    setMenuOpen(false);
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? 'bg-zinc-950/95 backdrop-blur-md py-3 border-b border-zinc-800'
          : 'bg-transparent py-6'
      }`}
    >
      <div className="w-full max-w-7xl mx-auto px-8 flex items-center justify-between">
        <span
          className="text-white font-bold text-lg tracking-widest cursor-pointer whitespace-nowrap"
          style={{ fontFamily: "'Space Grotesk', sans-serif" }}
          onClick={(e) => handleNavClick(e as unknown as React.MouseEvent<HTMLAnchorElement>, '#home')}
        >
          BORVIL OOD
        </span>

        <div className="hidden md:flex items-center gap-10">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="text-zinc-300 hover:text-emerald-400 text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {link.label}
            </a>
          ))}
        </div>

        <button
          className="md:hidden text-white cursor-pointer w-8 h-8 flex items-center justify-center"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <i className={`ri-${menuOpen ? 'close' : 'menu-3'}-line text-2xl`}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="md:hidden bg-zinc-950/98 backdrop-blur-md border-t border-zinc-800 px-8 py-6 flex flex-col gap-5">
          {navLinks.map((link) => (
            <a
              key={link.label}
              href={link.href}
              onClick={(e) => handleNavClick(e, link.href)}
              className="text-zinc-300 hover:text-emerald-400 text-sm font-medium tracking-wide transition-colors duration-200 cursor-pointer whitespace-nowrap"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              {link.label}
            </a>
          ))}
        </div>
      )}
    </nav>
  );
}
